import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './ProjectSection.css';
import ProjectCard from './ProjectCard.js';
import { projectData } from '../Data/ProjectData.js';


function ProjectSection({ onShowProjectDetails }) {

    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

  return (
    <section id="projects" className="py-20 bg-gray-50" ref={sectionRef}>
        <div className="max-w-6xl mx-auto px-6">
            <div className={`text-center mb-16 fade-in ${isVisible ? 'visible' : ''}`}>
                <h2 className="text-4xl font-bold text-gray-800 mb-4">Project Portfolio</h2>
                <p className="text-xl text-gray-600">Strategic initiatives delivered with measurable business impact</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {Object.entries(projectData).map(([projectId, project]) => (
                    <ProjectCard 
                        key={projectId}
                        project={project}
                        projectId={projectId}
                        onShowDetails={onShowProjectDetails}
                    />
                ))}
            </div>
        </div>
    </section>
  );
}

export default ProjectSection;